import { render } from "./LivraisonAddCommande.vue?vue&type=template&id=20630232"
import script from "./LivraisonAddCommande.vue?vue&type=script&lang=js"
export * from "./LivraisonAddCommande.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__